/**
 * The tags on applet frame messages, in a file of their own so the frame's
 * bundle can import them without zod (see `appletMessages.ts`).
 */

/**
 * Tags a message the frame posts to its host. The frame runs at an opaque
 * origin, so the host can't match on origin; it matches this tag instead.
 */
export const APPLET_MESSAGE_SOURCE = "okthx-applet";

/**
 * Tags a message the host posts into the frame. Native's bridge relays only
 * {@link APPLET_MESSAGE_SOURCE}, so a reply carrying this tag is never echoed
 * back to the host.
 */
export const APPLET_HOST_MESSAGE_SOURCE = "okthx-host";
